import { useStats } from 'app/webview/pages/stats_profile/lib/ctx/stats'
import { StreakCalendarGridItem } from './types'

export const useStreakCalendarGrid = () => {
  const [year, month] = useStats((s) => [s.year, s.streakMonth])

  const date = new Date(year, month - 1, 1)
  const firstDayIndex = date.getDay()
  const daysInMonth = new Date(year, month, 0).getDate()
  const prevMonthDays = new Date(year, month - 1, 0).getDate()
  const totalCells = firstDayIndex + daysInMonth > 35 ? 42 : 35

  const grid: StreakCalendarGridItem[] = new Array(totalCells)
    .fill(null)
    .map(() => ({
      day: null,
      isCurrentMonth: false,
    }))

  // Fill in the days of the current month
  for (let i = 0; i < daysInMonth; i++) {
    grid[firstDayIndex + i] = {
      day: i + 1,
      isCurrentMonth: true,
    }
  }

  // Fill in the days from the previous month
  for (let i = firstDayIndex - 1; i >= 0; i--) {
    grid[i] = {
      day: prevMonthDays - (firstDayIndex - 1 - i),
      isCurrentMonth: false,
    }
  }

  // Fill in the days from the next month
  for (let i = firstDayIndex + daysInMonth; i < totalCells; i++) {
    grid[i] = {
      day: i - (firstDayIndex + daysInMonth) + 1,
      isCurrentMonth: false,
    }
  }

  return grid
}
